import React, { useEffect, useState, Fragment } from 'react';
import classNames from 'classnames';
import ContentParser from 'src/ui/library/ContentParser';
import Spinner from 'src/ui/library/Spinner/Spinner';
import {
  QuestionnaireProfileList,
  QuestionnaireProfileDetails,
  QuestionnaireProfileDelete,
  upsertRelatedRecord,
} from 'src/services/accounts.service';
import { updatePageData } from 'src/new-ui/features/CaseDataCollect/state/caseDataCollectAction';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import intl from 'react-intl-universal';
import Button from 'src/ui/library/Button';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import { Edit, Delete } from '@material-ui/icons';
import { TableLanding } from 'src/ui/library/Table/extensions';
import { transformFormValues } from 'src/helpers';
import { toMoment } from 'src/helpers/date';
import WarningIcon from '@material-ui/icons/Warning';
import { fnIsDefaultOldView } from 'src/helpers/commonFunctions';

export const QuestionnaireSalaryPres = ({
  introData,
  pageData,
  push,
  isMobile,
  isTablet,
  match,
  setValidationFn,
  formValues,
  handleSave,
  gotoPage,
  onMenuExpand,
  isLoading,
  curExpandedMenu,
  updatedPage,
  isSaveLoading,
  rowId,
  employmentId,
  isSubmitted,
  ...props
}) => {
  const [entityRows, setEntityRows] = useState([]);
  const [entityColumns, setEntityColumns] = useState([]);
  const menus = pageData.menus || [];
  const [showDialog, setShowDialog] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [readOnly, setReadOnly] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [rowClickData, setRowClickData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(true);
  const [rowEntityId, setRowEntityId] = useState();
  const [searchTxt, setSearchTxt] = useState();
  const [sortCol, setSortCol] = useState();
  const [sorting, setSorting] = useState('asc');
  const [pageNo, setPageNo] = useState(1);
  const [entityLogicalName, setEntityLogicalName] = useState(pageData.entityLogicalName);
  const [salFormValues, setSalaryFormValues] = useState();
  const [validationError, setValidationError] = useState(false);
  const [saveNotDone, setSaveNotDone] = useState(false);
  const [deleteNotDone, setDeleteNotDone] = useState(false);
  useEffect(() => {
    if (pageData && pageData.isMultiline === true && entityLogicalName !== pageData.entityLogicalName) {
      setEntityLogicalName(pageData.entityLogicalName);
      setSearchTxt(null);
      setSorting(null);
      setSortCol(null);
      setIsLoaded(false);
      QuestionnaireProfileList({
        pageNumber: pageNo,
        searchText: searchTxt,
        pageSize: 15,
        sortDirection: sorting,
        entitySetName: 'questionaire',
        sortColumn: sortCol,
        entityId: rowId,
        entityLogicalName: 'ey_employmentsalaryprofileversion',
      }).then(response => {
        if (response && response.columns) {
          setEntityColumns(response.columns);
        }
        if (response && response.columns && response.rows) {
          const rdata = response.rows.map((row, index) => ({ ...row, index }));
          rdata && setEntityRows(rdata);
        }
      });
    }
    if (isLoaded === false)
      QuestionnaireProfileDetails({
        entityName: 'ey_employmentsalaryprofileversion',
        entityId: rowEntityId,
        questionaireId: employmentId,
        pageId: pageData.pageId,
      }).then(response => {
        if (response != null) {
          setRowClickData(response);
          setIsLoaded(true);
        }
      });
  }, [pageData, isLoaded, readOnly, rowEntityId, searchTxt]);

  const setFormValues = e => {
    updatePageData(e);
    setSalaryFormValues(e);
  };
  const handleOnClick = () => {
    setIsCreate(true);
    setReadOnly(false);

    setShowDialog(true);
  };
  const cancelshowViewDialog = () => {
    setShowDialog(false);
    setIsCreate(false);
    setReadOnly(true);
    setSaveNotDone(false);
    setDeleteNotDone(false);
  };
  const onCancelDialog = () => {
    setIsCreate(false);
    setReadOnly(true);
    setShowDialog(false);
    setSaveNotDone(false);
    setDeleteNotDone(false);
  };
  const onEdit = () => {
    setIsLoaded(false);
    setReadOnly(false);
  };
  const onDelete = () => {
    setDeleteNotDone(true);
    setShowDeleteModal(true);
  };
  const onCancelDeleteModal = () => {
    setShowDeleteModal(false);
    setReadOnly(true);
    setDeleteNotDone(false);
  };
  const onCancelEditModal = () => {
    setShowEditModal(false);
    setReadOnly(true);
    setSaveNotDone(false);
  };
  const onConfirmEditModal = () => {
    setReadOnly(false);
    setShowEditModal(false);
  };
  const onConfirmDeleteModal = () => {
    setDeleteNotDone(true);
    QuestionnaireProfileDelete({
      entityName: pageData.entityLogicalName,
      entityId: rowEntityId,
      pageId: pageData.pageId ? pageData.pageId : null,
      questionnaireId: pageData.entityId ? pageData.entityId : null,
    })
      .then(resp => {
        setDeleteNotDone(false);
      })
      .catch(e => {
        setDeleteNotDone(false);
      });
    setShowDeleteModal(false);
    setShowDialog(false);
  };
  const onSave = async () => {
    setSaveNotDone(true);
    setReadOnly(true);
    const data = {
      topLevelRecordId: employmentId,

      entityLogicalName: 'ey_employmentsalaryprofileversion',

      relationshipName: '',

      parentId: rowId,

      parentEntityName: 'ey_immigrationquestionnaire',

      entityId: isCreate ? '00000000-0000-0000-0000-000000000000' : rowEntityId,

      pageId: pageData.pageId ? pageData.pageId : null,

      ...transformFormValues(salFormValues.formValues),
    };

    await upsertRelatedRecord(data).then(
      result => {
        result && setRowEntityId(result.entityId);
        setIsCreate(false);
        setSaveNotDone(false);
        setShowDialog(false);
      },
      error => {},
    );
  };
  const getNumCols = () => {
    if (isTablet || isMobile) {
      return 1;
    }

    let numCols = 3;
    menus.forEach(m => {
      m.subMenu.forEach(sm => {
        if (sm.pageId === pageData.pageId && sm.numColumns) {
          numCols = sm.numColumns;
        }
      });
    });

    return numCols;
  };

  const onTableChange = (actionType, data, ...otherData) => {
    switch (actionType) {
      case 'cellClick':
        const rowIndex = data.cellClicked.rowIndex;
        const row = data.model.rows[rowIndex];
        row.forEach(column => {
          if (column.columnId === 'id') {
            setRowEntityId(column.value);
            setIsLoaded(false);
            setShowDialog(true);
          }
        });
        break;
      default:
        return undefined;
    }
  };
  const onValidate = (fields, setErrorFn) => {
    setValidationError(false);
    const { ey_effectiveenddate, ey_effectivestartdate } = fields;
    if (ey_effectivestartdate && ey_effectiveenddate) {
      if (toMoment(ey_effectiveenddate) < toMoment(ey_effectivestartdate)) {
        const errorMsg = (
          <span className="error-msg">
            <WarningIcon />
            <b>End date cannot occur before Start date</b>
          </span>
        );
        setErrorFn('ey_effectiveenddate', true, errorMsg);
        setValidationError(true);
      } else {
        setErrorFn('ey_effectiveenddate', false, null);
        setValidationError(false);
      }
    } else {
      setErrorFn('ey_effectiveenddate', false, null);
      setValidationError(false);
    }
  };

  const pageContainerClass = classNames({
    'questionnaire-page-container': true,
    'is-mobile': isMobile,
    'is-tablet': isTablet,
  });

  const filterPageDataForHostCompany = pageData => {
    return { ...pageData, lookUps: { ...pageData.lookUps } };
  };

  var isMultiline = pageData && pageData.isMultiline;
  return (
    <React.Fragment>
      <div className={pageContainerClass}>
        {isMultiline ? (
          <div className="content-parser-container">
            {showDialog && (
              <Dialog
                open
                aria-labelledby="dialog-title"
                fullWidth
                maxWidth="md"
                className={fnIsDefaultOldView() ? 'largemodal' : 'largemodal add-details-modal modal-details'}>
                <DialogTitle id="dialog-title">
                  Employment Salary
                  <IconButton aria-label="close" onClick={cancelshowViewDialog} className="close-button">
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <div className="content">
                    {showEditModal && (
                      <ConfirmDialog
                        open
                        title={intl.get(`${'profile'}.details.confirmDialogTitle`)}
                        cancelText={intl.get(`${'profile'}.details.buttons.cancelEdit`)}
                        confirmText={intl.get(`${'profile'}.details.buttons.continueEdit`)}
                        onCancel={onCancelEditModal}
                        onConfirm={onConfirmEditModal}>
                        {intl.get(`${'profile'}.details.cancelEditDialogMessage`)}
                      </ConfirmDialog>
                    )}
                    {showDeleteModal && (
                      <ConfirmDialog
                        open
                        title={intl.get(`${'profile'}.details.confirmDialogTitle`)}
                        cancelText={intl.get(`${'profile'}.details.buttons.cancel`)}
                        confirmText={intl.get(`${'profile'}.details.buttons.confirm`)}
                        onCancel={onCancelDeleteModal}
                        onConfirm={onConfirmDeleteModal}>
                        {intl.get(`${'profile'}.details.deleteRecordDialogMessage`)}
                      </ConfirmDialog>
                    )}
                    {isLoaded && !saveNotDone && !deleteNotDone ? (
                      <ContentParser
                        readOnly={!isCreate && readOnly}
                        key={pageData.pageId}
                        pageId={pageData.pageId}
                        data={isCreate ? filterPageDataForHostCompany(pageData) : rowClickData}
                        onChange={e => setFormValues(e)}
                        showLabels={false}
                        numberOfColumns={'3'}
                        forceNumberOfColumns={isMobile || isTablet}
                        debug={false}
                        fnValidateForm={setValidationFn}
                        onValidate={onValidate}
                      />
                    ) : (
                      <div style={{ marginTop: '10%', marginBottom: '10%' }}>
                        <Spinner size={50} />
                      </div>
                    )}
                  </div>
                </DialogContent>
                <DialogActions>
                  <section className="actions">
                    {!readOnly ? (
                      <div className="save-cancel-wrapper">
                        <Button styleType="secondary" onClick={onCancelDialog} className="action-button">
                          {intl.get(`${'profile'}.details.buttons.cancel`)}
                        </Button>
                        {salFormValues && (
                          <Button
                            className="action-button"
                            disabled={!salFormValues.isFormComplete || !isLoaded || validationError}
                            onClick={onSave}>
                            {intl.get(`${'profile'}.details.buttons.save`)}
                          </Button>
                        )}
                      </div>
                    ) : (
                      <Fragment>
                        {!isSubmitted && (
                          <div className="edit-delete-wrapper">
                            <a className="link" onClick={onEdit}>
                              <Edit className="icon" /> <span className="text">{intl.get(`${'profile'}.details.buttons.edit`)}</span>
                            </a>
                          </div>
                        )}
                        {!isSubmitted && (
                          <div className="edit-delete-wrapper right-end">
                            <a className="link" onClick={onDelete}>
                              <Delete className="icon" /> <span className="text">{intl.get(`${'profile'}.details.buttons.delete`)}</span>
                            </a>
                          </div>
                        )}
                      </Fragment>
                    )}
                  </section>
                </DialogActions>
              </Dialog>
            )}
            {!saveNotDone && !deleteNotDone ? (
              <TableLanding
                history={props.history}
                rowsPerPage={10}
                actionable={false}
                sortDirection={'asc'}
                columns={entityColumns}
                rows={entityRows}
                gridFilter={{
                  hideFilterButton: true,
                  render: TableFilter => (
                    <div className="landing-gridfilter-container">
                      {TableFilter}
                      <Button styleType="primary" disabled={isSubmitted} onClick={!isSubmitted && handleOnClick}>
                        <span>Add</span>
                      </Button>
                    </div>
                  ),
                }}
                pagination={true}
                hideLandingHeader={true}
                selectableRows={false}
                onRequestData={async (params, config) =>
                  await QuestionnaireProfileList(
                    {
                      ...params,
                      entitySetName: 'questionaire',
                      entityId: rowId,
                      entityLogicalName: 'ey_employmentsalaryprofileversion',
                      searchText: params.searchText,
                      sortDirection: sorting,
                      sortColumn: sortCol,
                      pageId: pageData.pageId ? pageData.pageId : null,
                    },
                    config,
                    setSearchTxt(params.searchText),
                    setPageNo(params.pageNumber),
                    setSorting(params.sortDirection),
                    setSortCol(params.sortColumn),
                  ).then(response => {
                    if (response && response.rows) {
                      const rdata = response.rows.map((row, index) => ({ ...row, index }));

                      rdata && setEntityRows(rdata);
                    }

                    if (response && response.columns) {
                      setEntityColumns(response.columns);
                    }
                    return response;
                  })
                }
                onTableChange={onTableChange}
                showCheckbox={false}
                isPageMandatory={pageData.isMandatory}
              />
            ) : (
              <div className="questionnaire-spinner">
                <Spinner size={60} />
              </div>
            )}
          </div>
        ) : (
          <div className="content-parser-container">
            {isLoading || !pageData.pageId ? (
              <div className="questionnaire-spinner">
                <Spinner size={60} />
              </div>
            ) : (
              <ContentParser
                key={pageData.pageId}
                pageId={pageData.pageId}
                data={filterPageDataForHostCompany(pageData)}
                onChange={setFormValues}
                showLabels={false}
                numberOfColumns={getNumCols()}
                forceNumberOfColumns={isMobile || isTablet}
                debug={false}
                fnValidateForm={setValidationFn}
              />
            )}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default QuestionnaireSalaryPres;
